import { useMemo, useState, useRef } from "react";
import UIkit from "uikit";
import { EMOJI_CATEGORIES } from "../../ui/emojiData";

export default function EmojiPicker({ onSelect }) {
  const [query, setQuery] = useState("");
  const dropdownRef = useRef(null);

  const filteredCategories = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return EMOJI_CATEGORIES;

    return EMOJI_CATEGORIES
      .map(cat => {
        const items = cat.items.filter(item => {
          const text = [
            item.emoji,
            item.label,
            ...(item.keywords || [])
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

          return text.includes(q);
        });

        return { ...cat, items };
      })
      .filter(cat => cat.items.length > 0);
  }, [query]);

  const resultCount = filteredCategories.reduce(
    (count, category) => count + category.items.length,
    0
  );

  const handleSelect = (emoji) => {
    onSelect?.(emoji);

    // close dropdown
    if (dropdownRef.current) {
      UIkit.dropdown(dropdownRef.current)?.hide(false);
    }

    setQuery("");
  };

  return (
    <div
      ref={dropdownRef}
      data-uk-dropdown="mode: click; pos: top-left; offset: 8"
      className="emoji-picker uk-card uk-card-default"
      aria-label="Emoji picker"
    >
      <div className="emoji-picker-header">
        <div>
          <div className="emoji-picker-title">Add an emoji</div>
          <div className="emoji-picker-subtitle">
            A friendly touch for every guest message
          </div>
        </div>
        <span className="emoji-picker-count">
          {resultCount} {resultCount === 1 ? "emoji" : "emojis"}
        </span>
      </div>

      <div className="emoji-search-wrap">
        <svg
          className="emoji-search-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          className="emoji-search-input"
          type="search"
          aria-label="Search emojis"
          placeholder="Search beach, whale, welcome..."
          autoComplete="off"
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={e => e.stopPropagation()}
        />
      </div>

      <div className="emoji-scroll uk-overflow-auto">
        {filteredCategories.length > 0 ? (
          filteredCategories.map(category => (
            <section key={category.key} className="emoji-category">
              <div className="emoji-category-header">
                {category.label}
              </div>

              <div className="emoji-grid">
                {category.items.map(item => {
                  const label = item.label || item.keywords?.[0] || "Emoji";

                  return (
                    <button
                      key={item.emoji}
                      type="button"
                      className="emoji-btn"
                      aria-label={label}
                      title={label}
                      onClick={() => handleSelect(item.emoji)}
                    >
                      <span aria-hidden="true">{item.emoji}</span>
                    </button>
                  );
                })}
              </div>
            </section>
          ))
        ) : (
          <div className="emoji-empty-state">
            <span aria-hidden="true">🔎</span>
            <strong>No emojis found</strong>
            <span>Try a vacation word like beach, pool, or welcome.</span>
          </div>
        )}
      </div>
    </div>
  );
}
